import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import axiosInstance from '../axiosConfig';

const UsersOverview = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.get('/admin/users', {
        headers: {
          Authorization: `${token}`,
        },
      });
      setUsers(response.data);
    };
    fetchUsers();
  }, []);

  return (
    <Box sx={{ ml: '1rem', mr: '1rem'}}>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Schulprofil</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user._id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.schoolName ? user.schoolName : 'Keinem Schulprofil zugeordnet'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default UsersOverview;
